/**
 * Ephemeral cross-lab handoff for "write a caption for this image" (D-7).
 *
 * The Asset Gallery's preview modal pushes an image asset here, then navigates
 * to `/labs/writer-lab/influencer`. WriterLab's mount effect consumes (reads +
 * clears) the asset and seeds its id as the Generate panel's `referenceImageId`
 * so the LLM gets the image as context.
 *
 * Single-slot, last-write-wins, not persisted — mirrors sourceHandoffStore.
 */

import { create } from 'zustand';
import type { AssetSummary } from '../domain';

interface CaptionHandoffState {
  pending: AssetSummary | null;
  setHandoff: (asset: AssetSummary) => void;
  consumeHandoff: () => AssetSummary | null;
  clearHandoff: () => void;
}

export const useCaptionHandoffStore = create<CaptionHandoffState>((set, get) => ({
  pending: null,
  setHandoff: (asset: AssetSummary) => set({ pending: asset }),
  consumeHandoff: () => {
    const pending = get().pending;
    if (pending !== null) set({ pending: null });
    return pending;
  },
  clearHandoff: () => set({ pending: null }),
}));
